import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Storage polyfill for browser (replaces window.storage from Claude artifacts)
window.storage = {
  _store: {},
  _shared: {},
  get: async (key, shared = false) => {
    const store = shared ? window.storage._shared : window.storage._store;
    // Try localStorage first, then in-memory
    try {
      const lsKey = (shared ? 'gwep_shared_' : 'gwep_') + key;
      const val = localStorage.getItem(lsKey);
      if (val !== null) return { key, value: val, shared };
    } catch (e) {}
    const val = store[key];
    if (val !== undefined) return { key, value: val, shared };
    throw new Error('Key not found: ' + key);
  },
  set: async (key, value, shared = false) => {
    const store = shared ? window.storage._shared : window.storage._store;
    store[key] = value;
    try {
      const lsKey = (shared ? 'gwep_shared_' : 'gwep_') + key;
      localStorage.setItem(lsKey, value);
    } catch (e) {}
    return { key, value, shared };
  },
  delete: async (key, shared = false) => {
    const store = shared ? window.storage._shared : window.storage._store;
    delete store[key];
    try {
      const lsKey = (shared ? 'gwep_shared_' : 'gwep_') + key;
      localStorage.removeItem(lsKey);
    } catch (e) {}
    return { key, deleted: true, shared };
  },
  list: async (prefix = '', shared = false) => {
    const keys = [];
    try {
      for (let i = 0; i < localStorage.length; i++) {
        const lsKey = localStorage.key(i);
        const pfx = shared ? 'gwep_shared_' : 'gwep_';
        if (lsKey && lsKey.startsWith(pfx)) {
          const k = lsKey.slice(pfx.length);
          if (k.startsWith(prefix)) keys.push(k);
        }
      }
    } catch (e) {}
    return { keys, prefix, shared };
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
